"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopilotRoadmapPlanSectionType = exports.PromptCategory = exports.CopilotRoadmapSectionStatusType = exports.CopilotRoadmapPlanStatusType = void 0;
var CopilotRoadmapPlanStatusType;
(function (CopilotRoadmapPlanStatusType) {
    CopilotRoadmapPlanStatusType["FirstStageInProgress"] = "FIRST_STAGE_IN_PROGRESS";
    CopilotRoadmapPlanStatusType["FirstStageCompleted"] = "FIRST_STAGE_COMPLETED";
    CopilotRoadmapPlanStatusType["FirstStageFailed"] = "FIRST_STAGE_FAILED";
    CopilotRoadmapPlanStatusType["SecondStageInProgress"] = "SECOND_STAGE_IN_PROGRESS";
    CopilotRoadmapPlanStatusType["SecondStageInFailed"] = "SECOND_STAGE_FAILED";
    CopilotRoadmapPlanStatusType["InProgress"] = "IN_PROGRESS";
    CopilotRoadmapPlanStatusType["Done"] = "DONE";
})(CopilotRoadmapPlanStatusType = exports.CopilotRoadmapPlanStatusType || (exports.CopilotRoadmapPlanStatusType = {}));
var CopilotRoadmapSectionStatusType;
(function (CopilotRoadmapSectionStatusType) {
    CopilotRoadmapSectionStatusType["InProgress"] = "IN_PROGRESS";
    CopilotRoadmapSectionStatusType["Failed"] = "FAILED";
    CopilotRoadmapSectionStatusType["Completed"] = "COMPLETED";
})(CopilotRoadmapSectionStatusType = exports.CopilotRoadmapSectionStatusType || (exports.CopilotRoadmapSectionStatusType = {}));
var PromptCategory;
(function (PromptCategory) {
    PromptCategory["CopilotRoadmapPlan"] = "COPILOT_ROADMAP_PLAN";
    PromptCategory["CopilotRoadmapPlanSuggestion"] = "COPILOT_ROADMAP_PLAN_SUGGESTION";
})(PromptCategory = exports.PromptCategory || (exports.PromptCategory = {}));
var CopilotRoadmapPlanSectionType;
(function (CopilotRoadmapPlanSectionType) {
    CopilotRoadmapPlanSectionType["BasicInformation"] = "BASIC_INFORMATION";
    CopilotRoadmapPlanSectionType["OverallAssessment"] = "OVERALL_ASSESSMENT";
    CopilotRoadmapPlanSectionType["MajorEvaluation"] = "MAJOR_EVALUATION";
    CopilotRoadmapPlanSectionType["AcademicStrategy"] = "ACADEMIC_STRATEGY";
    CopilotRoadmapPlanSectionType["TestingStrategy"] = "TESTING_STRATEGY";
    CopilotRoadmapPlanSectionType["ActivitiesStrategy"] = "ACTIVITIES_STRATEGY";
    CopilotRoadmapPlanSectionType["HonorStrategy"] = "HONOR_STRATEGY";
    CopilotRoadmapPlanSectionType["FurtherSuggestion"] = "FURTHER_SUGGESTION";
    CopilotRoadmapPlanSectionType["OtherSuggestion"] = "OTHER_SUGGESTION";
    CopilotRoadmapPlanSectionType["Conclusion"] = "CONCLUSION";
})(CopilotRoadmapPlanSectionType = exports.CopilotRoadmapPlanSectionType || (exports.CopilotRoadmapPlanSectionType = {}));
//# sourceMappingURL=copilotRoadmapPlanType.js.map